import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';

const config = {
  apiKey: 'AIzaSyAuAE4urKLlc1vuNRYwnE6QXGBsc-LsUCQ',
  authDomain: 'pius-development.firebaseapp.com',
  databaseURL: 'https://pius-development.firebaseio.com',
  projectId: 'pius-development',
  storageBucket: 'pius-development.appspot.com',
  messagingSenderId: '368404925292',
  appId: '1:368404925292:web:08cc27b77646c766cf0149',
};

const firebaseapp = firebase.initializeApp(config);
export const db = firebaseapp.firestore();
export const auth = firebaseapp.auth();
export const storage = firebaseapp.storage();
